export class Logger {
    constructor({ enableDebugLogging, debugFn, infoFn, warnFn, errorFn, }) {
        this.enableDebugLogging = enableDebugLogging === undefined ? false : enableDebugLogging;
        this.infoFn = infoFn || console.log;
        this.warnFn = warnFn || console.warn;
        this.errorFn = errorFn || console.error;
        // for backward compatibility: if no debug log function is provided, fall back to the info callback
        this.debugFn = debugFn || infoFn || console.debug;
    }
    debug(...args) {
        if (this.enableDebugLogging) {
            this.debugFn(...args);
        }
    }
    info(...args) {
        this.infoFn(...args);
    }
    warn(...args) {
        this.warnFn(...args);
    }
    error(...args) {
        this.errorFn(...args);
    }
}
//# sourceMappingURL=logger.js.map